import { Component, Input, OnInit, inject } from '@angular/core';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Loan } from 'src/model/loan.model';
import { Receipt } from 'src/model/loanReceipt.model';
import { LoanService } from 'src/services/loan.service';

@Component({
    selector: 'app-repayment-compare',
    templateUrl: './repayment-compare.component.html',
    styleUrl: './repayment-compare.component.scss',
    standalone: false
})
export class RepaymentCompareComponent implements OnInit {
  private enums = inject(Enums);
  private sharedService = inject(SharedService);
  private loanService = inject(LoanService);

  @Input() receiptList: Receipt[] = [];
  @Input() epfDate: Date;

  repaymentWithCharges = 0;
  paymentLoans: Loan[] = [];
  supposedSettlement: { loan: Loan; settlement: number, date: Date }[] = [];
  isCollapsed = true;

  async ngOnInit(): Promise<void> {

    //get receipts contains repayment transaction
    const repaymentReceipt = this.receiptList.filter(receipt => receipt.Transactions.some(transaction => transaction.Type == this.enums.REPAYMENT));

    if (repaymentReceipt.length > 0) {
      //get the REPAYMENT transaction
      const repaymentTransactions = repaymentReceipt.reduce((acc, entry) => {
        const match = (entry.Transactions || []).filter(sub => sub.Type === this.enums.REPAYMENT);
        return acc.concat(match);
      }, []);

      //get the respective loan
      const allUniqueSubIds = [
        ...new Set(
          repaymentTransactions.map(transaction => transaction.LoanId)
        )
      ];

      this.paymentLoans = await this.loanService.getLoans(allUniqueSubIds);

      // Compute list with final settlement
      this.supposedSettlement
        = this.paymentLoans.map(item => ({
          loan: item,
          date: repaymentTransactions.find(t => t.LoanId == item.ID).Date,
          settlement: this.sharedService.roundTo2Dec(this.sharedService.calculateSettlementToDate(item, repaymentTransactions.find(t => t.LoanId == item.ID).Date, this.epfDate)),

        }));

      this.repaymentWithCharges = this.getTotalRepaymentWithCharges(repaymentReceipt);
    }
  }

  getRepaymentDifference() {
    return this.repaymentWithCharges - this.getTotalSupposedSettlement();
  }

  updateSettlementDate(index: number) {
    const loan = this.supposedSettlement[index].loan;
    const date = this.supposedSettlement[index].date;
    console.log(date)
    this.supposedSettlement[index].settlement = this.sharedService.roundTo2Dec(this.sharedService.calculateSettlementToDate(loan, date, this.epfDate));
  }

  getTotalSupposedSettlement() {
    return this.supposedSettlement.reduce((total, item) => {
      return total + item.settlement
    }, 0);
  }

  getTotalRepaymentWithCharges(repaymentReceipt: Receipt[]) {

    return repaymentReceipt.reduce((sum, entry) => {
      const subtotal = entry.Transactions.reduce((s, t) => {

        //makes sure undefined values are treated as 0
        const val = t.Amount ?? 0;
        // adds only positive numbers / DISCOUNT transaction type
        return (val > 0 || t.Type == this.enums.DISCOUNT) ? s + val : s;
      }, 0) || 0;
      return sum + subtotal
    }, 0)
  }

}
